export default __webpack_public_path__ + "static/media/pic1.79a08fc0.jpg";